module.exports = __webpack_public_path__ + "static/media/interview23_s.5307c494.jpg";